// extracted by mini-css-extract-plugin
var _1 = "ImageCaption-module__animateUploadProgressBarWidth--VaG0x";
var _2 = "ImageCaption-module__animatedBackground--G_0UZ";
var _3 = "ImageCaption-module__caption--AczKE";
var _4 = "ImageCaption-module__captionContainer--xZzHq";
var _5 = "ImageCaption-module__empty--rVT7N";
var _6 = "ImageCaption-module__hide--oTVsp";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "caption", _4 as "captionContainer", _5 as "empty", _6 as "hide" }
